"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserType = void 0;
exports.UserType = {
    ANONYMOUS: 'Anonymous',
    BASIC: 'Basic',
    ADMIN: 'Admin',
};
